import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '../common/Button';

export const BetaRequestSubmitted = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-[#3D3F42] flex items-center justify-center p-4">
      <div className="w-full max-w-md">
        <div className="bg-[#2A2B2E] rounded-lg p-8 text-center">
          <h2 className="text-2xl font-bold text-white mb-4">Request Submitted</h2>
          <p className="text-gray-400 mb-6">
            Thank you for your interest in our beta program. Your request has been submitted for review.
            You will receive an email once your access has been approved.
          </p>
          <Button
            onClick={() => navigate('/login')}
            className="bg-red-600 hover:bg-red-700 text-white"
          >
            Return to Login
          </Button>
        </div>
      </div>
    </div>
  );
};